import { io } from 'socket.io-client';

///export const socket = io('http://192.168.100.242:3000');
export const socket = io('https://imagen.cetemin.net.pe:4001');

//export const socket = io('https://operatic.cetemin.edu.pe:4000');